export default __webpack_public_path__ + "63da5c29047c8f9f7b1c5bac6c3002ab.svg";